import { InHouseInputSelect } from '@celito.clients/shared';
import { raiseErrorToast } from '@celito.clients/utils';
import { getObjectLifeCycle } from 'apps/web-client/src/screens/Platform/admin-ui-screen/services/lifecycle-object';
import { IOption } from 'libs/shared/src/lib/in-house-input-select/in-house-input-select.model';
import { useEffect, useState } from 'react';
import { Controller, useFormContext } from 'react-hook-form';

interface RenderStagesProps {
  objectName: string;
  index: number;
  formPath: string;
}
export const RenderStages = ({
  objectName,
  index,
  formPath,
}: RenderStagesProps) => {
  const [isLoading, setIsLoading] = useState(false);
  const [objectLifecycleData, setObjectLifecycleData] = useState<IOption[]>([]);

  const methods = useFormContext();

  const { control } = methods;

  useEffect(() => {
    fetchLifecycleData();
  }, [objectName]);

  const fetchLifecycleData = async () => {
    if (objectName) {
      setIsLoading(true);
      getObjectLifeCycle(objectName)
        .then((res) => {
          const options: IOption[] = res?.stages?.map((stage) => {
            return { text: stage.label, value: stage.label };
          });

          options && setObjectLifecycleData(options);
        })
        .catch((_error) => {
          raiseErrorToast(_error);
        })
        .finally(() => setIsLoading(false));
    }
  };

  return (
    <Controller
      name={`${formPath}.${index}.validations.stage`}
      control={control}
      render={({ field, fieldState: { error } }) => (
        <InHouseInputSelect
          helperLabelText="Select object to pick stages"
          label={'Stages'}
          options={objectLifecycleData}
          isLoadingOptions={isLoading}
          selectedOptions={field.value}
          onOptionSelect={(e, data) => field.onChange(data.selectedOptions)}
          errorMessage={error?.message}
          required
          multiselect
        />
      )}
    />
  );
};
